/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModifyBookNotificationConfigurationDataCmd } from '../../models/modify-book-notification-configuration-data-cmd';
import { ValidationError } from '../../models/validation-error';

export interface UpdateNotificationConfigData$Params {

/**
 * id configuration type book
 */
  id: string;
      body?: ModifyBookNotificationConfigurationDataCmd
}

export function updateNotificationConfigData(http: HttpClient, rootUrl: string, params: UpdateNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, updateNotificationConfigData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

updateNotificationConfigData.PATH = '/api/configuration/{id}/book/notification';
